(() => {
  /**
   * Adds Conductrics session data to the cart attributes.
   * This function retrieves the current Conductrics session and updates the cart with it.
   *
   * @async
   * @function addConductricsToCartAttribute
   * @returns {Promise<void>} A promise that resolves when the cart is updated.
   */
  async function addConductricsToCartAttribute() {
    try {
      // Initialize Conductrics Client API
      const clientApi = new Conductrics.ClientApi();

      // Get the current session from Conductrics
      const session = clientApi.h.sess_get();

      // Update the cart with the session data
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            __conductrics_sess: session,
          },
        }),
      });

      // Check if the response is okay
      if (!response.ok) {
        throw new Error(`Failed to update cart: ${response.statusText}`);
      }
    } catch (error) {
      // Log the error to the console for debugging
      console.error('Error updating cart:', error);
    }
  }

  // Add Conductrics session data to the cart attributes when the DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      addConductricsToCartAttribute();
    });
  });
})();
